<template>
    <component :is="component" v-if="localized" v-bind="$props" />
    <div class="monthlyPayment-content" v-else>
        {{ $t("review-table.monthlyPaymentAmount", {formattedMonthlyPayment:formattedMonthlyPayment, creditTerm: creditTerm}) }}
    </div>
</template>

<script>
import LocalizedComponentMixin from "@/components/localization/LocalizedComponentMixin"
import { formatCurrency } from "@/util/currency"

export default {
    name: "PaymentPlanMonthlyPayment",
    mixins: [
        LocalizedComponentMixin,
    ],
    props: {
        financedAmountCents: {
            type: Number,
        },

        paymentPlan: {
            type: Object,
            required: true,

        },
    },
    data() {
        return {
            componentType: "paymentPlanMonthlyPayment",
            formattedMonthlyPayment: formatCurrency(this.paymentPlan?.monthlyAmountCents),
            creditTerm: this.paymentPlan?.durationMonths,
        }
    },
}
</script>
